export const DataFields = (t) => {
  return [
    {
      name: t('designmenu_typography_form_category_section'),
      fields: [
        {
          id: "fontSizeNameCategory",
          name: t('designmenu_typography_form_category_name_size'),
          type: "number",
          required: true,
          defaultValue: 38,
          tooltip: t('designmenu_typography_form_category_name_size_tooltip'),
          inputProps: { min: 10, max: 60 },
          endAdornment: { value: "px" },
          startAdornment: null,
          size: "small"
        },
        {
          id: "fontSizeDescriptionCategory",
          name: t('designmenu_typography_form_category_description_size'),
          type: "number",
          required: true,
          defaultValue: 24,
          tooltip: t('designmenu_typography_form_category_description_size_tooltip'),
          inputProps: { min: 10, max: 60 },
          endAdornment: { value: "px" },
          startAdornment: null,
          size: "small"
        },
        {
          id: "fontSizeFooterCategory",
          name: t('designmenu_typography_form_category_footer_size'),
          type: "number",
          required: true,
          defaultValue: 20,
          tooltip: t('designmenu_typography_form_category_footer_size_tooltip'),
          inputProps: { min: 10, max: 60 },
          endAdornment: { value: "px" },
          startAdornment: null,
          size: "small"
        }
      ]
    },
    {
      name: t('designmenu_typography_form_subcategory_section'),
      fields: [
        {
          id: "fontSizeNameSubcategory",
          name: t('designmenu_typography_form_subcategory_name_size'),
          type: "number",
          required: true,
          defaultValue: 32,
          tooltip: t('designmenu_typography_form_subcategory_name_size_tooltip'),
          inputProps: { min: 10, max: 60 },
          endAdornment: { value: "px" },
          startAdornment: null,
          size: "small"
        },
        {
          id: "fontSizeDescriptionSubcategory",
          name: t('designmenu_typography_form_subcategory_description_size'),
          type: "number",
          required: true,
          defaultValue: 24,
          tooltip: t('designmenu_typography_form_subcategory_description_size_tooltip'),
          inputProps: { min: 10, max: 60 },
          endAdornment: { value: "px" },
          startAdornment: null,
          size: "small"
        },
        {
          id: "fontSizeFooterSubcategory",
          name: t('designmenu_typography_form_subcategory_footer_size'),
          type: "number",
          required: true,
          defaultValue: 20,
          tooltip: t('designmenu_typography_form_subcategory_footer_size_tooltip'),
          inputProps: { min: 10, max: 60 },
          endAdornment: { value: "px" },
          startAdornment: null,
          size: "small"
        }
      ]
    },
    {
      name: t('designmenu_typography_form_product_section'),
      fields: [
        {
          id: "fontSizeNameProduct",
          name: t('designmenu_typography_form_product_name_size'),
          type: "number",
          required: true,
          defaultValue: 28,
          tooltip: t('designmenu_typography_form_product_name_size_tooltip'),
          inputProps: { min: 10, max: 60 },
          endAdornment: { value: "px" },
          startAdornment: null,
          size: "small"
        },
        {
          id: "fontSizeDescriptionProduct",
          name: t('designmenu_typography_form_product_description_size'),
          type: "number",
          required: true,
          defaultValue: 24,
          tooltip: t('designmenu_typography_form_product_description_size_tooltip'),
          inputProps: { min: 10, max: 60 },
          endAdornment: { value: "px" },
          startAdornment: null,
          size: "small"
        },
        {
          id: "fontSizeNameVariantProduct",
          name: t('designmenu_typography_form_variant_name_size'),
          type: "number",
          required: true,
          defaultValue: 28,
          tooltip: t('designmenu_typography_form_variant_name_size_tooltip'),
          inputProps: { min: 10, max: 60 },
          endAdornment: { value: "px" },
          startAdornment: null,
          size: "small"
        },
        {
          id: "fontSizeDescriptionVariantProduct",
          name: t('designmenu_typography_form_variant_description_size'),
          type: "number",
          required: true,
          defaultValue: 24,
          tooltip: t('designmenu_typography_form_variant_description_size_tooltip'),
          inputProps: { min: 10, max: 60 },
          endAdornment: { value: "px" },
          startAdornment: null,
          size: "small"
        },
        {
          id: "fontSizePriceVariantProduct",
          name: t('designmenu_typography_form_variant_price_size'),
          type: "number",
          required: true,
          defaultValue: 28,
          tooltip: t('designmenu_typography_form_variant_price_size_tooltip'),
          inputProps: { min: 10, max: 60 },
          endAdornment: { value: "px" },
          startAdornment: null,
          size: "small"
        }
      ]
    },
  ]
}